import { use } from "react";
import {
  ResetCodeRequestDTO,
  SignInRequestDTO,
  SignUpRequestDTO,
  StringAnswerDTO,
  UpdatePasswordRequestDTO,
} from "../api/Api";
import { API } from "../config/api";
import {
  localStorageService,
  LocalStorageVariableName,
} from "./localStorage-service";

class AuthService {
  async login(user: SignInRequestDTO) {
    try {
      let res = API.api.signIn(user);
      let result = (await res).data;
      localStorageService.setValue(
        LocalStorageVariableName.token,
        result.token
      );
      return 200;
    } catch (err: any) {
      console.error(err);
      if (err.status == 401) {
        return "Неверные учетные данные";
      }
      if (err.status == 404) {
        return "Пользователь с указанным email не найден";
      }
    }
  }

  async logout() {
    try {
      localStorageService.deleteValue(LocalStorageVariableName.token);
      return 200;
    } catch (err: any) {
      console.error(err);
      return 500;
    }
  }

  async registration(user: SignUpRequestDTO) {
    try {
      let res = API.api.signUp(user);
      let result = (await res).data;
      // localStorageService.setValue(
      //   LocalStorageVariableName.token,
      //   result.token
      // );
      return 200;
    } catch (err: any) {
      console.error(err);
      if (err.status == 400) {
        return "Ошибка валидации данных";
      }
      if (err.status == 409) {
        return "Пользователь с таким email уже существует";
      }
    }
  }

  async sendCodeRecoveryPassword(login: ResetCodeRequestDTO) {
    try {
      let res = API.api.sendResetCode(login);
      let result = (await res).data as StringAnswerDTO;

      return 200;
    } catch (err: any) {
      console.error(err);
      return "Пользователь с указанным email не найден";
    }
  }

  async recoveryPassword(password: UpdatePasswordRequestDTO) {
    try {
      let res = API.api.updatePassword(password);
      let result = (await res).data as StringAnswerDTO;

      return 200;
    } catch (err: any) {
      console.error(err);
      if (err.status == 400) {
        return "Ошибка валидации или неправильный код восстановления";
      }
      if (err.status == 404) {
        return "Пользователь с указанным email не найден";
      }

      return "Внутренняя ошибка сервера";
    }
  }
}

export const authService: AuthService = new AuthService();
